import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import { Row, Col, Button, Card, Label,Input, FormGroup } from "reactstrap";
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faDownload, faEye,faPause,faSave ,faRedo } from "@fortawesome/free-solid-svg-icons";
import AddCMAssetCommentsService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/AddCMAssetCommentsService";
import DeleteCMFileAssetService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/DeleteCMFileAssetService";
import FetchCMAssetChatsService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMAssetChatsService";
import UploadAllTypeOfPDAssetsFile from "../UploadProjectDashAssets/UploadAllTypeOfPDAssetsFile";
import CustomModal from "../../../../../../../Components/Modals/CustomModal";
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import AssetStatusChangeService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/AssetStatusChangeService";
import SubmitIcon from '../../../../../../../../designUtils/ProjectDashboard/SubmitIcon.svg';
import SubmittedIcon from '../../../../../../../../designUtils/ProjectDashboard/SubmittedIcon.svg';
import DeleteIcon from '../../../../../../../../designUtils/ProjectDashboard/DeleteIcon.svg';
import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import CommentIcon from '../../../../../../../../designUtils/ProjectDashboard/CommentIcon.svg';
import FetchCMProductDataService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService";
import NewCMProductListScreen from "../AssetAnnotations/NewCMProductListScreen";
import AssetsCommentsPopup from "../AssetAnnotations/AssetsCommentsPopup";
import UpdateDestinationCatAndAsinlistService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/UpdateDestinationCatAndAsinlistService";
import NewTaskIcon from '../../../../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import FetchSubmissionsChatsService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService";
import EditDoneIcon from '../../../../../../../../designUtils/ProjectDashboard/EditDoneIcon.svg';
import FilesMoveToAssetGalleryService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FilesMoveToAssetGalleryService";
import MoveToAssetGallery from '../../../../../../../../designUtils/OpsDashboard/MyTasks/MoveToAssetGallery.svg';
import notify from '../../../../../../../../Notifications/ToastifyActions';

function ProjectDashBrandInterviewAndAudit(props) {

  const [showUploadComponent, setShowUploadComponent] = useState(false);
  const [downloading, setdownloading] = useState(false)
  const [selectedFileObject, setSelectedFileObject] = useState(null);
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [note, setNote] = useState('');
  const [noteList, setNoteList] = useState([]);
  const [assetsName, setAssetsName] = useState('');
  const [loadScreen, setLoadScreen] = useState(false);
  const [isDeleteConfirmPopUpOPen, setIsDeleteConfirmPopUpOPen] = useState(false);
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [expandedNote, setExpandedNote] = useState(null);
  const [demoImage, setDemoImage] = useState()
  const [fileName, setFileName] = useState('')
  const [isFileNamePopUpOPen, setIsFileNamePopUpOPen] = useState(false)
  const [searchText, setSearchText] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [action,setAction] = useState();
  const [categoryError, setCategoryError] = useState("");
  const [isOnlineDocSignOffConfirm, setIsOnlineDocSignOffConfirm] = useState(false);
  const [selectedDestinationSubCategories, setSelectedDestinationSubCategories] = useState();
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('All');
  const [addProductsPopupFroMultipleAsin,setAddProductsPopupFroMultipleAsin]= useState(false);
  // const [selectedDestinationSubCategories, setSelectedDestinationSubCategories] = useState(selectedFileObject.destinationSubCategoriesId?selectedFileObject.destinationSubCategoriesId:'');
  const [expandedNotes, setExpandedNotes] = useState({});
  const [asinList, setAsinList] = useState([]);
  const [assetsDetails,setAssetsDetails]=useState('')
  const [addProductsPopup, setAddProductsPopup] = useState(false)
  const [productList, setProductList] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // const listStatus = [ 7, 8, 9, 10, 11, 4, 5,13 ];
  const listStatus = [ 7, 8, 9, 11, 10, 4, 13, 5,15 ];
  // 7-New , 8-In progress, 9-complete, 10-Signed Off, 11-Rejected, 4-Send For Approval, 5-Approved,13- rework , 15-Moved to Asset Gallery
  const statusOptions = [
   { text: 'All' },
   ...Object.values(props.fileStatus || {})
     .filter(statusObj => listStatus.includes(statusObj.id))
     .sort((a, b) => listStatus.indexOf(a.id) - listStatus.indexOf(b.id))];

 const filteredData = props.fileList && props.fileList.filter(file => {

   const isAllowedStatus = listStatus.includes(file.status);

   const search = searchText.trim().toLowerCase();

   const matchesSearch = search === '' || (
     (file.actualFileName && file.actualFileName.toLowerCase().includes(search)) ||
     (file.fileType && file.fileType.toLowerCase().includes(search)) ||
     (file.destinationProductSubCategoryMap && file.destinationProductSubCategoryMap.toLowerCase().includes(search)) ||
     (file.statusText && file.statusText.toLowerCase().includes(search)) ||
     (file.asinList && file.asinList.toLowerCase().includes(search)) ||
     (file.createdAt && file.createdAt.toLowerCase().includes(search)) ||
     (file.updatedBy && file.updatedBy.toLowerCase().includes(search))
   );

   const matchesStatusFilter = selectedStatusFilter === 'All' || file.statusText === selectedStatusFilter;
   return isAllowedStatus && matchesSearch && matchesStatusFilter;
 });

  useEffect(()=>{
    if(selectedFileObject){
      setAssetsDetails(selectedFileObject)
      setAsinList(selectedFileObject.asinList)
    }
  },[selectedFileObject])
  const addCMAssetChats = () => {
    if (!selectedFileObject) return;
    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      note: note,
      assetDetails: selectedFileObject.id,
      action:action
    };
    AddCMAssetCommentsService(props.token, data).then((res) => {
      if (res) {
        setNoteList(res.noteList);
        setAction("")
        setNote('');
        props.setFileList(res.fileList.fileList)
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        if (res.updatedStatus) {
          props.setFileList((prevList) =>
            prevList.map((file) =>
              file.id === selectedFileObject.id
                ? { ...file, statusText: res.updatedStatus.text, statusColor: res.updatedStatus.color }
                : file
            )
          );
        }
      }
    });
  };
  const getCMAssetChat = (file) => {
    console.log(file);
    let data = {
      assetDetails: file.id
    }
    setSelectedFileObject(file);
    setSelectedDestinationSubCategories(file.destinationSubCategoriesId)
    setAsinList(file.asinList)

    setLoadScreen(true);
    FetchCMAssetChatsService(props.token, data).then((res) => {
      setNoteList(res);
      setLoadScreen(false);
    })
    setAssetsName(file.actualFileName);
    setIsCommentsPopUpOPen(true);
    showNote(file.fileName, file.filePath, file)
  };

  const showNote = (path, fullPath,file) => {
    console.log(path);
    const ext = path.split(".")[1];
    if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
      setDemoImage(true)
  
    }else {
      setFilePath(fullPath);
      setDemoImage(false)
    }
  };

  const handleDownloadImage = async (url, type, fileObject) => {
    if (type === "DownloadeImage") {
      try {
        setdownloading(fileObject.id);

        const response = await fetch(url, {
          method: 'GET',
          referrerPolicy: 'no-referrer',
          cache: 'no-store',
        });

        if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.id}`);

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = fileObject.actualFileName || 'downloaded_file';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        URL.revokeObjectURL(blobUrl);
        setdownloading(false);
      } catch (error) {
        console.error('Failed to download files:', error);
        setdownloading(false);
      }
    } else {
      try {
        setdownloading(fileObject.id);

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.originalGA[0].id}`);

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = fileObject.originalGA[0].actualFileName || 'downloaded_file';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        URL.revokeObjectURL(blobUrl);
        setdownloading(false);
      } catch (error) {
        console.error('Failed to download files:', error);
        setdownloading(false);
      }
    }
  };

  const handleDeleteFile = (fromEditable) => {
    let data = {
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      fileId: selectedFileObject.id,
      fileType: fromEditable === 'true' ? 'graphic' : 'image',
    };
    DeleteCMFileAssetService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        props.setFileList(res.fileList.fileList);
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        setIsDeleteConfirmPopUpOPen(false);
        // setSelectedFileObject(null);
      }
    });
  };
  const handleChangeStatus = (status, id) => {
    let data = {
      status: status,
      selectedImgId: id,
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
    };
  
    if (selectedDestinationSubCategories) {
      data.destinationSubCategories = selectedDestinationSubCategories;
      const selectedCategory = props.filterSubcategoryList && props.filterSubcategoryList.find(
        cat => cat.id == selectedDestinationSubCategories
      );
      if (selectedCategory) {
        data.destinationSubCategoryName = selectedCategory.subCategoryName;
      }
    }
  
    if (asinList && asinList.length > 0) {
      data.asinList = Array.isArray(asinList) 
        ? asinList.join(',') 
        : asinList;
    }
  
    console.log('Sending data:', data);
    
    AssetStatusChangeService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        
        // Update the file list with new data
        props.setFileList(res.fileList.fileList);
        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }
        // Clear form state after successful update
        setSelectedDestinationSubCategories("");
        setAsinList([]);
      }
    });
  };
// Handle destination subcategory change
const handleDestinationSubCategories = (e) => {
  setSelectedDestinationSubCategories(e.target.value);
};

const handleSelectProduct=()=>{
  // setStoreName(props.selectedProjectData.storeName);
  let data={
      // integerID:intergerId
      asinList:props.selectedProjectData.asin,
          projectId: props.selectedProjectData.projectId,
          integerID: props.selectedProjectData.integerId
  }
  FetchCMProductDataService(props.token,data).then((res)=>{
      if(res){
          console.log(res)
          setProductList(res.productsList)
          setAddProductsPopup(true)
      }
  })
} 
const handleSelectProductFroMultipleAsin=()=>{
  console.log('handleSelectProductFroMultipleAsin');
   let data={
    // integerID:intergerId
          projectId: props.selectedProjectData.projectId,
          asinList:props.selectedProjectData.asin,
    integerID: props.selectedProjectData.integerId
}
FetchCMProductDataService(props.token,data).then((res)=>{
   if(res){
       console.log(res)
       setProductList(res.productsList)
       setAddProductsPopupFroMultipleAsin(true)
   }
})
}
const updateDestinationCategory = (destinationCategoryId) => {
  if (!selectedFileObject || !destinationCategoryId) return;

  const data = {
    asinList: asinList || '',
    fileID: selectedFileObject.id,
    integerId: props.selectedProjectData.integerId,
    assetCategory: props.selectedSubCategories.assetCategory,
    assetIdentifier: props.selectedProjectData.brand,
    projectId: props.selectedProjectData.projectId,
    subCategoryId: props.selectedSubCategories.id,
    destinationSubCategories: destinationCategoryId
  };

  return UpdateDestinationCatAndAsinlistService(props.token, data)
    .then((res) => {
      if (res) {
        props.setFileList(res.fileList.fileList);

        if (res.fileList && res.fileList.assetStatusCount) {
          props.setAssetsStatusCount(res.fileList.assetStatusCount);
        }

        const updatedFile = res.fileList.fileList.find(
          f => f.id === selectedFileObject.id
        );
        if (updatedFile) {
          setSelectedFileObject(updatedFile);
        }
      }
      return res;
    });
};


const handleContinueToConfirm = () => {
  if (!selectedDestinationSubCategories) {
    setCategoryError("Please select a destination category.");
    return; 
  }

  updateDestinationCategory(selectedDestinationSubCategories)
    .then(() => {
      setIsSelectionModalOpen(false);
      setIsConfirmationModalOpen(true);
    });
};

const handleDestinationCategoryChangeImmediate = (e) => {
    const newCategoryId = e.target.value;
    setSelectedDestinationSubCategories(newCategoryId);
    setCategoryError("");
    
    // Add a promise handler to ensure state updates
    updateDestinationCategory(newCategoryId).then(() => {
        console.log('Category updated successfully');
    });
};

  const handleMoveToAssetgallery = () => {
    if (!selectedFileObject) return;
  
    let data = {
      id: selectedFileObject.id,
      integerId: props.selectedProjectData.integerId,
      assetCategory: props.selectedSubCategories.assetCategory,
      assetIdentifier: props.selectedProjectData.brand,
      projectId: props.selectedProjectData.projectId,
      subCategoryId: props.selectedSubCategories.id,
      destinationCategoriesId: selectedFileObject.destinationCategoriesId,
      destinationSubCategoriesId: selectedFileObject.destinationSubCategoriesId,
      asinList: asinList || '',
      projectName: props.selectedProjectData.projectName
    };
  
    FilesMoveToAssetGalleryService(props.token, data).then((res) => {
      if (!res) return;
  
      //Backend validation error → popup
      if (res.error) {
        setErrorMessage(res.message || 'Something went wrong.');
        setErrorModalOpen(true);
        return;
      }
  
      // Success
      if (res.fileList) {
        props.setFileList(res.fileList.fileList);
        props.setAssetsStatusCount(res.fileList.assetStatusCount);
        setIsAttachmentOpen(false);
        notify.NotifySuccess(
          "The asset has been moved to asset gallery successfully."
        );
      }
    });
  };
  
  // Handles the final 'Confirm' button on the second modal
  const handleFinalConfirm = () => {
    console.log('Final confirmation with:', {
      selectedDestinationSubCategories,
      asinList
    });
    handleChangeStatus(9, selectedId);
    setIsConfirmationModalOpen(false);
    setSelectedId(null);
  };
  const handleOpenPopup=(e,fileUrl,isPDF,cellInfo)=>{
    console.log(cellInfo)
    if (isPDF) {
      setFilePath(fileUrl);
      setSelectedFileObject(cellInfo);
      setSelectedDestinationSubCategories(cellInfo.destinationSubCategoriesId)
      setAsinList(cellInfo.asinList)


      setIsAttachmentOpen(true);
      if(cellInfo.statusText==="Re-Work"){
        let data={
          assetId:cellInfo.id
        }
        FetchSubmissionsChatsService(props.token,data).then((res)=>{
          if(res){
            console.log(res)
            // setPartnerComments()
            setNoteList(res);
            // setCommentPopupOpen(true);
          }
        })
       
      }
     
    } else {
      window.open(fileUrl, "_blank"); // open/download other files
    }
  }
  const getShortText = (htmlText, wordLimit = 75) => {
    //  ADD SAFETY CHECK: Return empty string if htmlText is null/undefined
    if (!htmlText || typeof htmlText !== 'string') {
      return '';
    }
    
    const text = htmlText.replace(/<[^>]+>/g, ""); 
    const words = text.split(/\s+/);
    
    if (words.length <= wordLimit) return htmlText;
    
    const truncated = words.slice(0, wordLimit).join(" ") + "...";
    return truncated;
  };
  const toggleReadMore = (index) => {
    setExpandedNotes(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  
  const columns = [
    // {
    //   Header: "File Name",
    //   accessor: "actualFileName",
    //   Cell: (cellInfo) => {
    //     return (
    //       <div className="d-flex justify-content-center w-100 ">
    //         <p className="m-0 comment-paragraph cursor-pointer" title={cellInfo.value}>
    //           <a href={cellInfo.original.assetUrl || cellInfo.original.filePath}
    //                  target="_blank" rel="noopener noreferrer">
    //             {cellInfo.value}
    //           </a>
    //         </p>
    //       </div>
    //     );
    //   },
    // },
    {
      Header: "File Name",
      accessor: "actualFileName",
      Cell: (cellInfo) => {
        const fileUrl = cellInfo.original.assetUrl || cellInfo.original.filePath;
        const fileName = cellInfo.value || "";
        const extension = fileName.split('.').pop().toLowerCase();
        const isPDF = extension === "pdf";
    
        return (
          <div className="d-flex justify-content-center w-100">
            <p
              className="m-0 comment-paragraph cursor-pointer"
              title={fileName}
              onClick={(e) => {
                handleOpenPopup(e,fileUrl,isPDF,cellInfo.original)
                e.preventDefault();}}
            >
              {fileName}
            </p>
          </div>
        );
      },
    },
    
    {
      Header: "File Type",
      accessor: "fileType",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
      disableSortBy: true,
      sortable: false,
    },
    {
      Header: "Destination Category",
      accessor: "destinationProductSubCategoryMap",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p  title ={cellInfo.value} className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "statusText",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p className="m-0 comment-paragraph justify-content-center">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Asin List",
      accessor: "asinList",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p title ={cellInfo.value} className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Uploaded At",
      accessor: "createdAt",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Uploaded By",
      accessor: "updatedBy",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 ">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Actions",
      width: 237,
      accessor: "fileName",
      Cell: (cellInfo) => {
        const fileName = cellInfo.value || "";
        const ext = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
        const isImage = ["jpg", "jpeg", "png", "gif", "svg"].includes(ext);
        const isVideo = ["mp4", "mov", "avi", "mkv"].includes(ext);
        const isPreviewable = isImage || isVideo || ext === "pdf";
    
        const isOnlineDoc =
          cellInfo.original.fileType.toLowerCase() === "online_doc" ||
          (!ext && cellInfo.original.assetUrl);
    
        return (
          <div className="d-flex justify-content-center align-items-center">
            {/* Always show comment */}
            {cellInfo.original.status != 13 &&  //13- Re-Work
            <button
              onClick={() => {getCMAssetChat(cellInfo &&cellInfo.original); setAction("")} }
              className="btn"
            >
              <img
                src={CommentIcon}
                height={20}
                width={20}
                title="Notes"
                alt="Notes"
              />
            </button>}
    
            {/* Online Doc: show only Verify + Delete */}
            {isOnlineDoc ? (
              <>
              {cellInfo.original.status ===7 || cellInfo.original.status ===8 ?// 7 new 8 inprogress
                  (<img
                    src={EditDoneIcon}
                    alt="Complete"
                    height={20}
                    width={20}
                    style={{ cursor: "pointer" }}
                    title="Complete"
                    // onClick={() => handleChangeStatus(9, cellInfo.original.id)}
                    onClick={() => {
                      setSelectedId(cellInfo.original.id);
                      setSelectedFileObject(cellInfo.original)
                      setSelectedDestinationSubCategories(cellInfo.original.destinationSubCategoriesId)
                      setFileName(cellInfo.original.actualFileName)
                     setAsinList(cellInfo.original.asinList)

                     setIsSelectionModalOpen(true);
                      setCategoryError(""); 
                     
                    }}
                    className="ml-2"
                  />):''
                }
               {/* 9 status- Complete */}
              {cellInfo.original.status === 9 && props.projectPermissions.ProjectAssetsDocument_SignOff &&
                <img
                  src={SubmitIcon}
                  alt="Submit"
                  height={20}
                  width={20}
                  className="ml-2"
                  style={{ cursor: "pointer" }}
                  title="Submit"
                  onClick={() => {
                    setSelectedId(cellInfo.original.id);
                    setFileName(cellInfo.original.actualFileName)
                    setIsSubmit(true);
                  }}
                />}
              {[10, 4,5,12,15].includes(cellInfo.original.status) && props.accessLevel === 5 ? '' :
                // status 10- Signed Off , 4-Sent for Approval, 5-Approved, 12-Re-Work, 15- Moved to Assets Gallery
                <img
                  src={DeleteIcon}
                  alt="Delete"
                  height={20}
                  width={20}
                  className="ml-3"
                  style={{ cursor: "pointer" }}
                  title="Delete"
                  onClick={() => {
                    setSelectedFileObject(cellInfo.original);
                    setSelectedDestinationSubCategories(cellInfo.original.destinationSubCategoriesId)
                  setAsinList(cellInfo.original.asinList)

                    setIsDeleteConfirmPopUpOPen(true);
                  }}
                />}
              </>
            ) : (
              <>
               
                {cellInfo.original.status ===7 || cellInfo.original.status ===8 ? // 7 new 8 inprogress
                  (<img
                    src={EditDoneIcon}
                    alt="Resume"
                    height={20}
                    width={20}
                    style={{ cursor: "pointer" }}
                    title="Complete"
                    // onClick={() => handleChangeStatus(9, cellInfo.original.id)}
                    onClick={() => {
                      setSelectedFileObject(cellInfo.original)
                  setAsinList(cellInfo.original.asinList)

                      setSelectedDestinationSubCategories(cellInfo.original.destinationSubCategoriesId)
                      setSelectedId(cellInfo.original.id);
                      setFileName(cellInfo.original.actualFileName)
                      setIsSelectionModalOpen(true);
                      setCategoryError(""); 
                    }}
                    className="ml-3"
                  />):''
                }
    
                <img
                  src={DownloadIcon}
                  alt="Download"
                  height={20}
                  width={20}
                  className="ml-3"
                  style={{ cursor: "pointer" }}
                  title="Download"
                  onClick={() =>
                    handleDownloadImage(cellInfo.original.filePath, "DownloadeImage", cellInfo.original)
                  }
                />
                {/* 9 status-Complete */}
     {cellInfo.original.status === 9 && props.projectPermissions.ProjectAssetsDocument_SignOff &&
                <img
                  src={SubmitIcon}
                  alt="Submit"
                  height={20}
                  width={20}
                  className="ml-3"
                  style={{ cursor: "pointer" }}
                  title="Submit"
                  onClick={() => {
                    setSelectedId(cellInfo.original.id);
                    setFileName(cellInfo.original.actualFileName)
                    setIsSubmit(true);
                  }}
                />}
                {/* 10-Signed Off, 4-Sent for Approval, 5-Approved, 13-Re-Work, 14-Move to Assets Gallery,15-Move to Assets Gallery */}
                {!(
                    [14, 15].includes(cellInfo.original.status) ||
                    ([10, 4, 5, 13].includes(cellInfo.original.status) &&
                      props.accessLevel === 5)
                  ) && (
                    <img
                      src={DeleteIcon}
                      alt="Delete"
                      height={20}
                      width={20}
                      className="ml-3"
                      style={{ cursor: "pointer" }}
                      title="Delete"
                      onClick={() => {
                        setSelectedFileObject(cellInfo.original);
                        setSelectedDestinationSubCategories(
                          cellInfo.original.destinationSubCategoriesId
                        );
                        setIsDeleteConfirmPopUpOPen(true);
                        setAsinList(cellInfo.original.asinList);
                      }}
                    />
                  )}
                  </>
            )}
          </div>
        );
      },
    }
    
    
  ];

  const handleBackFromUploadAssets = (data, type) => {
    setShowUploadComponent(false);
  };

 
  return (
    <>
      {showUploadComponent ? (
        <UploadAllTypeOfPDAssetsFile
          setFiles={props.setFileList}
          selectedProjectData={props.selectedProjectData}
          selectedSubCategories={props.selectedSubCategories}
          filterSubcategoryList={props.filterSubcategoryList}
          handleBackFromUploadAssets={handleBackFromUploadAssets}
          setAssetsStatusCount={props.setAssetsStatusCount}
          assetIdentifier={props.selectedProjectData.brand}
          // flagNumber={10}
          setFileListOfAssets={() => { }}
          setAllFileListOfAssets={() => { }}
        />
      ) : (
        <Row className='ml-2'>
          <Col md={12} className="d-flex justify-content-end mb-1">
          <div className="d-flex">
            <Input 
              type="text"
              placeholder="Search Text"
              className="mr-3" 
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Button
              className="btn-background-color-Proceed-gallery w-75"
              onClick={() => setShowUploadComponent(true)}
            >
              Upload Assets
            </Button>
          </div>
          </Col>
          <Col md={12} className="d-flex justify-content-between align-items-start">
          <div className="d-flex flex-wrap">
          {statusOptions.map((status) => {
        const statusCount = status.text === 'All' 
          ? Object.values(props.assetsStatusCount || {})
              .reduce((sum, count) => sum + count, 0)
          : (props.assetsStatusCount && props.assetsStatusCount[status.text]) || 0;

        return (
          <div className="status-radio-wrapper" key={status.text}>
            <label
              className={`status-radio-label ${status.text.trim().replace(/\s+/g, '-')} ${selectedStatusFilter === status.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                name="statusFilter"
                value={status.text}
                checked={selectedStatusFilter === status.text}
                onChange={() => setSelectedStatusFilter(status.text)}
              />
              <span className="ml-2"></span>
              {status.text}
              <b
                className="assetsStatusCount"
                style={{
                  minWidth: `${Math.max(16, statusCount.toString().length * 10)}px`,
                  minHeight: `${Math.max(16, statusCount.toString().length * 10)}px`,
                  padding: `4px ${Math.max(6, statusCount.toString().length * 3)}px`
                }}
              >
                {statusCount}
              </b>
      </label>
    </div>
  );
})}

          </div>
          </Col>
          <Col md={12} className="mt-3">
            <ReactTable
              data={filteredData}
              columns={columns}
              className="-fixed -highlight -striped"
              getTheadProps={() => ({
                style: {
                  overflow: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              })}
              defaultPageSize={10}
              noDataText="No data found..."
            />
          </Col>
        </Row>
      )}
    <CustomModal
        isOpen={isCommentsPopUpOPen}
        toggle={() => setIsCommentsPopUpOPen(false)}
        size="xl"
        header={<p title={assetsName} className="comment-paragraph-Project-asin-title">{assetsName}</p>}
        className="curve-popup "
      >
        <LoadingOverlay
          active={loadScreen}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text="Loading chat details..."
        >
         
       
        <AssetsCommentsPopup
        filePath={filePath}
        demoImage={demoImage}
        noteList={noteList}
        setNote={setNote}
        action={true}
        note={note}
        selectedFileObject={selectedFileObject}
        addCMAssetChats={addCMAssetChats}
        />
         </LoadingOverlay>
      </CustomModal>
      <CustomModal
        isOpen={isFileNamePopUpOPen}
        toggle={() => setIsFileNamePopUpOPen(false)}
        size={"sm"}
        className="curve-popup"
      >
        <Card className='curve-popup p-3'>
          <Col md={12}>
            <p>{fileName}</p>
          </Col>
        </Card>
      </CustomModal>
      <CustomModal
        header={<> {selectedFileObject?selectedFileObject.actualFileName:'Atachment'}
          <FontAwesomeIcon
            className={`ml-3 ${downloading ? 'button-img-background-download-inprogress' : ''}`}
            style={{ cursor: 'pointer' }}
            icon={faDownload}
            onClick={() => handleDownloadImage(filePath, "DownloadeImage", selectedFileObject)}
          />
        </>}
        isOpen={isAttachmentOpen}
        toggle={() => { setIsAttachmentOpen(!isAttachmentOpen); setdownloading(false) }}
        size={"xl"}
        className='curve-popup'
       
      >
       {selectedFileObject && selectedFileObject.status!==13? <Row>
          <Col md={12}>
          <Label>
          <div>
            <iframe
              src={filePath}
              title="File Display"
              width="100%"
              height="500"
            ></iframe>
          </div>
        </Label>
          </Col>
          {selectedFileObject && selectedFileObject.status==5? // status 5 - Approved
           (<Col md={8} className="mt-1">
            <div className="d-flex align-items-center">
              <span className="mr-3 font-weight-bold">
                Destination Category :
              </span>

              <Input
                type="select"
                value={selectedDestinationSubCategories}
                onChange={handleDestinationCategoryChangeImmediate}
                className="form-control"
                style={{
                  width: "auto",
                  minWidth: "360px",
                  marginLeft: 0
                }}
              >
                <option disabled value="">--Select Category--</option>
                {props.filterSubcategoryList &&
                  props.filterSubcategoryList.map((subCategory) => (
                    <option key={subCategory.id} value={subCategory.id}>
                      {subCategory.subCategoryName} ({subCategory.assetCategory__categoryName})
                    </option>
                  ))}
              </Input>
            </div>
          </Col>):
          (
            <Col md={8} className="mt-1 d-flex justify-content-start">
              <h6 className="mb-0">
                <b>Destination Category : </b> {assetsDetails.destinationProductSubCategoryMap || ''}
              </h6>
            </Col>)
         }
          <Col md={4} className='mt-1'>
          <h6>
              <b>Status :</b> &nbsp;&nbsp;
              <span className={`documents-view-label ${
              (assetsDetails.statusText || '').replace(/\s+/g, '-').replace(/^\w/, c => c.toUpperCase())
            }`}>
              {assetsDetails.statusText || ''}
            </span>
            </h6>
          </Col>
          <Col md={8} className="mt-2">
            <div
              style={{
                maxHeight: "105px",
                overflowY: "auto",
                fontSize: "14px",
              }}
            >
              <b className="mr-3">ASIN List : </b>{' '}
              {
                (Array.isArray(asinList)
                  ? asinList
                  : typeof asinList === 'string'
                  ? asinList.split(',')
                  : []
                )
                .map(asin => (typeof asin === 'string' ? asin.trim() : asin))
                .join(', ')
              }
            </div>
          </Col>
          {selectedFileObject && selectedFileObject.status==5? // status 5 - Approved
          <Col md={4}>
          <Button
            className="btn-background-color w-50 mb-2 mr-2"
            onClick={() => { handleSelectProductFroMultipleAsin() }}
          >
            Map ASINs
            <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
          </Button>
          {props.projectPermissions.ProjectDetailsProjectAssets_MovetoAssetGallery &&
          <Button
            className="w-50 mb-2"
            onClick={() => { handleMoveToAssetgallery() }}
            style={{ backgroundColor: '#80ffbc', color: '#243837' }}
          >
            Move to Asset Gallery
            <img className='ml-2 mb-1' src={MoveToAssetGallery} style={{ height: '18px' }} />
          </Button>}
          </Col>:''}
        </Row>:
        <Row>
          <Col md={6}>
          <Row>
          <Col md={12}>
        <Label>
        <div>
          <iframe
            src={filePath}
            title="File Display"
            width="100%"
            height="500"
          ></iframe>
        </div>
      </Label>
        </Col>
        <Col md={8} className="mt-1 d-flex justify-content-start">
          <h6 className="mb-0">
            <b>Destination Category : </b> {assetsDetails.destinationProductSubCategoryMap || ''}
          </h6>
        </Col>
        <Col md={4} className='mt-1'>
        <h6>
            <b>Status :</b> &nbsp;&nbsp;
            <span className={`documents-view-label ${
            (assetsDetails.statusText || '').replace(/\s+/g, '-').replace(/^\w/, c => c.toUpperCase())
          }`}>
            {assetsDetails.statusText || ''}
          </span>
          </h6>
        </Col>
        <Col md={8} className="mt-1">
          <div
            style={{
              maxHeight: "105px",
              overflowY: "auto",
              fontSize: "14px",
            }}
          >
            <b>ASIN List : </b>{' '}
            {
              (Array.isArray(asinList)
                ? asinList
                : typeof asinList === 'string'
                ? asinList.split(',')
                : []
              )
              .map(asin => (typeof asin === 'string' ? asin.trim() : asin))
              .join(', ')
            }
          </div>
        </Col>
          </Row>
          </Col>
          <Col md={6} className="p-3 comment-card">
    <div className="comments-box scrollable-div p-0 overflow-auto">
      {(noteList || []).length > 0 ? (
        noteList.map((note, index) => {
          //  ADD SAFETY CHECK HERE TOO
          const noteText = note.notes || '';
          const plainText = noteText.replace(/<[^>]+>/g, "");
          const wordCount = plainText.split(/\s+/).filter(Boolean).length;
          
          return (
            <div key={index}>
              <div
                className={`d-flex p-2 ${
                  note.loggedInUser === 1
                    ? "justify-content-end"
                    : "justify-content-start align-items-end"
                }`}
              >
                <div className="d-flex align-items-start">
                  {note.loggedInUser === 0 && (
                    <div className="p-1 user-short-name">
                      {(note.userShortName || '').toUpperCase()}
                    </div>
                  )}
                  <p
                    className={`p-2 mb-0 ${
                      note.loggedInUser === 1
                        ? "chat-background-color-sent"
                        : "chat-background-color"
                    }`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: expandedNotes[index]
                          ? noteText
                          : getShortText(noteText, 75)
                      }}
                    />
                    {wordCount > 75 && (
                      <span
                        className="text-primary cursor-pointer"
                        style={{ fontWeight: "bold" }}
                        onClick={() => toggleReadMore(index)}
                      >
                        {expandedNotes[index] ? " Read Less" : " Read More"}
                      </span>
                    )}
                    <span className="text-right text-muted d-block">
                      {note.submittedOn || ''}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p className="text-muted px-2 mt-3">No Comments</p>
      )}
    </div>
  </Col>
      
     
      </Row>
        }
       
      </CustomModal>
      <CustomModal
        isOpen={isDeleteConfirmPopUpOPen}
        toggle={() => { setIsDeleteConfirmPopUpOPen(!isDeleteConfirmPopUpOPen); }}
        size={"md"}
        className="curve-popup"
      >
        <Card className="curve-popup p-3 ">
          <Row>
            <Col md={12}>
              <div>
                <h6>
                  Are you sure you want to delete file?
                </h6>
              </div>
              <div className='mb-2'>
                <Button
                  onClick={() => handleDeleteFile(selectedFileObject, 'true')}
                  className='delete-button-background-none mt-1'
                  disabled={!selectedFileObject}>
                  <FontAwesomeIcon icon={faTrash} /> &nbsp;
                  Delete
                </Button> &nbsp;
                <Button
                  onClick={() => {  setIsDeleteConfirmPopUpOPen(!isDeleteConfirmPopUpOPen) }}
                  className=' mt-1'>
                  Cancel
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      <CustomModal
        isOpen={isSubmit}
        toggle={() => setIsSubmit(false)}
        size="md"
        className="curve-popup"
        header={<p title={fileName} className="comment-paragraph-ticket-history">{fileName}</p>}
      >
        <Card className="curve-popup p-3">
          <Row>
            <Col md={12}>
              <div>
                <h6>What would you like to do with this document?</h6>
              </div>
              <div className='mb-2 d-flex justify-content-end mr-4 mt-4'>
              <Button
                className="no-btn-background-color mr-2"
                onClick={() => {
                  setIsSubmit(false);
                  
                  const fileObject = props.fileList.find(file => file.id === selectedId);
                  if (fileObject) {
                    getCMAssetChat(fileObject);setAction("")
                  }
                    setAction("true")

                    setIsCommentsPopUpOPen(true)
                    setSelectedId(null);
                }}
              >
                Notes
              </Button>
              <Button
                 className=" no-btn-background-color mr-2"
                  onClick={() => {
                    handleChangeStatus(11, selectedId);
                    setIsSubmit(false);
                    setSelectedId(null);
                  }}
                >
                  Reject
                </Button>
                &nbsp;
                {/* <Button
                  className='btn-background-color'
                  onClick={() => {
                    handleChangeStatus(10, selectedId);
                    setIsSubmit(false);
                    setSelectedId(null);
                  }}
                >
                  Sign Off
                </Button> */}
                <Button
                  className='btn-background-color'
                  onClick={() => {
                    // Find the current file object to check if it's an online doc
                    const currentFile = props.fileList.find(file => file.id === selectedId);
                    const isOnlineDoc = currentFile && (
                      currentFile.fileType.toLowerCase() === "online_doc" || 
                      ((!currentFile.fileName || !currentFile.fileName.includes(".")) && currentFile.assetUrl)
                    );
                    
                    if (isOnlineDoc) {
                      // If it's an online doc, close current modal and show confirmation
                      setIsSubmit(false);
                      setIsOnlineDocSignOffConfirm(true);
                      handleChangeStatus(10, selectedId);
                    } else {
                      // If it's not an online doc, proceed as usual
                      handleChangeStatus(10, selectedId);
                      setIsSubmit(false);
                      setSelectedId(null);
                    }
                  }}
                >
                  Sign Off
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
      <CustomModal
          header={
            <div className="d-flex">
              Map ASINs for :  <b title={selectedFileObject && selectedFileObject.actualFileName} className="comment-paragraph-ticket-history ml-2">{selectedFileObject && selectedFileObject.actualFileName ? selectedFileObject.actualFileName:''}</b>
            </div>
          }
        isOpen={addProductsPopup}
        toggle={() => {
            setAddProductsPopup(!addProductsPopup)
        }}
        size={"lg"}
       className='my-task-custom-module'
      >
        <NewCMProductListScreen
        selectedProjectData= {props.selectedProjectData}
        selectedSubCategories ={props.selectedSubCategories}
         selectedImage={selectedFileObject}
         setFileListOfAssets={props.setFileList}
         setSelectedImage={setSelectedFileObject}
        //  selectedStatus={selectedStatus}
        //  setSelectedStatus={setSelectedStatus}

      //  setFileList= {props.setFileList}
        setAddProductsPopup={setAddProductsPopup}
        asinList={asinList}
        setAsinList={setAsinList}
        singleSelect={true}
        // setSelectedAsin={setSelectedAsin}
        action={true}
        productList={productList}
        />
      
      </CustomModal>
      <CustomModal
          header={
            <div className='d-flex'>
              Map ASINs for :  <b title= {selectedFileObject && selectedFileObject.actualFileName} className="comment-paragraph-ticket-history ml-2">{ selectedFileObject && selectedFileObject.actualFileName || ''}</b>
            </div>
          }
        isOpen={addProductsPopupFroMultipleAsin}
        toggle={() => {
            setAddProductsPopupFroMultipleAsin(!addProductsPopupFroMultipleAsin)
        }}
        size={"lg"}
       className='my-task-custom-module'
      >

        <NewCMProductListScreen
        // setSelectedASIN={''}
        documentScreen={true}
        selectedProjectData= {props.selectedProjectData}
        selectedSubCategories ={props.selectedSubCategories}
         selectedImage={selectedFileObject}
         setFileListOfAssets={props.setFileList}
         setSelectedImage={setSelectedFileObject}
         setAsinAssetCounts={props.setAsinAssetCounts}
        setAssetsStatusCount={props.setAssetsStatusCount}
        //  selectedStatus={selectedStatus}
        // setSelectedASIN={''}
        //  setSelectedStatus={setSelectedStatus}
        setAddProductsPopup={setAddProductsPopupFroMultipleAsin}
        asinList={asinList}
        setAsinList={setAsinList}
        // setSelectedAsin={setSelectedAsin}
        action={false}
        productList={productList}
        />
        {/* <ViewProjectAsinList
              projectData={props.selectedProjectData}
              asinList={asinArray}
            /> */}
      
      </CustomModal>
<CustomModal
    isOpen={isSelectionModalOpen}
    toggle={() => setIsSelectionModalOpen(false)}
    size="md"
    className="curve-popup"
    header={<p title={fileName} className="comment-paragraph-ticket-history">{fileName}</p>}
>
    <Card className="curve-popup p-3">
        <Row>
            <Col md={12}>
                <div className="mb-4">
                  <Row>
                  <h6 className="ml-2 mb-4">
                        Confirm the Destination Category and Asin List for this document.
                    </h6>
                  </Row>
                    <Row className="align-items-center mb-3">
                        <Col md={4}>
                            <Label><strong>Destination Category <span className="text-danger">*</span>:</strong></Label>
                        </Col>
                        <Col md={8}>
                            <Input
                                type="select"
                                value={selectedDestinationSubCategories}
                                onChange={(e) => {
                                    handleDestinationSubCategories(e);
                                    setCategoryError("");
                                }}
                                className="form-control"
                            >
                                <option value="">--Select Category--</option>
                                {props.filterSubcategoryList && props.filterSubcategoryList.map((subCategory) => (
                                    <option key={subCategory.id} value={subCategory.id}>
                                        {subCategory.subCategoryName}
                                        {" "}
                                        ({subCategory.assetCategory__categoryName})
                                    </option>
                                ))}
                            </Input>
                            {categoryError && (
                                <div className="text-danger mt-1">{categoryError}</div>
                            )}
                        </Col>
                    </Row>

                    <Row className="align-items-start mb-3">
                        <Col md={4}>
                            <Label><strong>ASIN List:</strong></Label>
                        </Col>
                        <Col md={8}>
                            {asinList && asinList.length > 0 && (
                                <div
                                    className="border rounded pl-3 pt-2 pb-2 mb-3"
                                    style={{ maxHeight: "75px", overflowY: "auto" }}
                                >
                                    {(Array.isArray(asinList) ? asinList : asinList.toString().split(',')).map((asin, index) => (
                                        <div key={index}>
                                            {typeof asin === 'string' ? asin.trim() : asin}
                                        </div>
                                    ))}
                                </div>
                            )}
                            <Button
                                className="btn-background-color w-100 mt-1"
                                onClick={() => handleSelectProduct()}
                                size="sm"
                            >
                                Map ASINs
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="d-flex justify-content-end border-top pt-3">
                    <Button className="no-btn-background-color mr-3" onClick={() => setIsSelectionModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button className="btn-background-color"  onClick={() => handleContinueToConfirm()} >
                        Confirm and Continue
                    </Button>
                </div>
            </Col>
        </Row>
    </Card>
</CustomModal>


{/* CONFIRMATION MODAL */}
<CustomModal
    isOpen={isConfirmationModalOpen}
    toggle={() => setIsConfirmationModalOpen(false)}
    size="md"
    className="curve-popup"
    header={<p title={fileName} className="comment-paragraph-ticket-history">{fileName}</p>}
>
    <Card className="curve-popup p-3">
        <Row>
            <Col md={12}>
                <div className="mb-4">
                    <Row className="align-items-center mb-3">
                        <Col md={4}>
                            <Label><strong>Destination Category:</strong></Label>
                        </Col>
                        <Col md={8}>
                            <Input
                                type="select"
                                value={selectedDestinationSubCategories}
                                className="form-control"
                                disabled // This is the key change
                            >
                                <option value="">--Select Category--</option>
                                {props.filterSubcategoryList && props.filterSubcategoryList.map((subCategory) => (
                                    <option key={subCategory.id} value={subCategory.id}>
                                        {subCategory.subCategoryName}
                                        {" "}
                                        ({subCategory.assetCategory__categoryName})
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </Row>

                    <Row className="align-items-start mb-3">
                        <Col md={4}>
                            <Label><strong>ASIN List:</strong></Label>
                        </Col>
                        <Col md={8}>
                            {asinList && asinList.length > 0 ? (
                                <div
                                    className="border rounded pl-3 pt-2 pb-2"
                                    style={{ maxHeight: "75px", overflowY: "auto" }}
                                >
                                    {(Array.isArray(asinList) ? asinList : asinList.toString().split(',')).map((asin, index) => (
                                        <div key={index}>
                                            {typeof asin === 'string' ? asin.trim() : asin}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="border rounded p-2 text-muted">
                                    No ASINs mapped.
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>

                <div className="border-top pt-3">
                    <h6 className="mb-3">
                        Are you sure you want to mark this asset as 'Complete' for Sign Off?
                    </h6>
                    <div className="d-flex justify-content-end">
                        <Button
                            className="no-btn-background-color mr-3"
    
    onClick={() => {setIsConfirmationModalOpen(false);setSelectedId(null);}}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="btn-background-color"
                            onClick={handleFinalConfirm}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </Col>
        </Row>
    </Card>
</CustomModal>


      <CustomModal
          isOpen={isOnlineDocSignOffConfirm}
          toggle={() => setIsOnlineDocSignOffConfirm(false)}
          size="md"
          className="curve-popup"
          header={<p title={fileName} className="comment-paragraph-ticket-history">{fileName}</p>}
        >
          <Card className="curve-popup p-3">
            <Row>
              <Col md={12}>
                <div>
                  <h6>Please note, you need to physically upload this document in pdf or relevant format in project folder to be available for submission.</h6>
                </div>
                <div className='mb-2 d-flex justify-content-end mr-4'>
                  {/* <Button
                    className="no-btn-background-color mr-2"
                    onClick={() => {
                      setIsOnlineDocSignOffConfirm(false);
                      setSelectedId(null);
                    }}
                  >
                    No
                  </Button> */}
                  <Button
                    className='btn-background-color'
                    onClick={() => {
                      // handleChangeStatus(10, selectedId);
                      setIsOnlineDocSignOffConfirm(false);
                      setSelectedId(null);
                    }}
                  >
                    ok
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </CustomModal>
        <CustomModal
          isOpen={errorModalOpen}
          toggle={() => setErrorModalOpen(false)}
          size="md"
          className="curve-popup"
          header="Action Required"
        >
          <Card className="curve-popup p-3">
            <Row>
              <Col md={12}>
                <p className="mb-2">{errorMessage}</p>

                <div className="d-flex justify-content-end mt-4">
                  <Button
                    className="btn-background-color"
                    onClick={() => setErrorModalOpen(false)}
                  >
                    OK
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </CustomModal>

    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
});
export default connect(mapStateToProps)(ProjectDashBrandInterviewAndAudit);
